import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Container, AsLinkLoginButton, Sanitise, CallToActionButton, HeroBanner, UnAuthenticated} from "@careers-wales/react-components";
import {useNavigate} from 'react-router-dom';
import {route} from "../../../routes";
import {Cy} from "@careers-wales/react-components";
function LandingView(props) {
    // Hooks.
    const {t} = useTranslation();
    // Navigate.
    const navigate = useNavigate();
    return (
        <>
            <HeroBanner source={"https://publicfiles.careerswales.gov.wales/images/banner_decision_making.webp"}>
                <Sanitise tag={"p"} className="cta__title" string={t('view.landing.banner.title')} />
             <Sanitise  tag={"p"} className="cta__title"string={t('view.landing.banner.subtitle')} />
                <CallToActionButton
                    ariaLabel={t('view.landing.banner.ctaAria')}
                    onPress={() => {
                    props.setCurrentStage(0);
                    navigate(route('quiz'))
                }
                }>{t('view.landing.banner.ctaText')}</CallToActionButton>
            </HeroBanner>
            <Container>
                <h2>{t('view.landing.about.title')}</h2>
                <div>{t('view.landing.about.body')}</div>
                <br/>
                <p><strong>{t('view.landing.how.title')}</strong></p>
                <ul  className="style--list-square  style--list-no-bg">
                    <li>{t('view.landing.how.bullet.1')}</li>
                    <li>{t('view.landing.how.bullet.2')}</li>
                    <UnAuthenticated>
                        <li>
                            <Trans i18nKey={'view.landing.how.bullet.3'}>
                                <AsLinkLoginButton />
                            </Trans>
                        </li>
                    </UnAuthenticated>
                </ul>
                <CallToActionButton
                    ariaLabel={t('view.landing.banner.ctaAria')}
                    onPress={() => {
                        console.log('setting ucrrent stage');
                        props.setCurrentStage(0);
                        navigate(route('quiz'))
                    }
                }>{t('view.landing.banner.ctaText')}</CallToActionButton>
            </Container>
        </>
    )
}
export default LandingView;
